<template><section><template>
<h3>下拉框</h3>
<div class="bs-docs-section">
<div class="bs-example">
  <n3-dropdown>
    <div slot="trigger">
      <n3-button>
        点击
        <n3-icon :type="show?'angle-up' : 'angle-down'"></n3-icon>
      </n3-button>
    </div>
    <li><a href="#">Action</a></li>
    <li><a href="#">Another action</a></li>
    <li><a href="#">Something else here</a></li>
  </n3-dropdown>
</div>
<pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">n3-dropdown</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">slot</span>=<span class="hljs-string">"trigger"</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">n3-button</span>&gt;</span>
      点击
      <span class="hljs-tag">&lt;<span class="hljs-name">n3-icon</span> <span class="hljs-attr">:type</span>=<span class="hljs-string">"show?'angle-up' : 'angle-down'"</span> &gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">n3-icon</span>&gt;</span>
    <span class="hljs-tag">&lt;/<span class="hljs-name">n3-button</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">li</span>&gt;</span><span class="hljs-tag">&lt;<span class="hljs-name">a</span> <span class="hljs-attr">href</span>=<span class="hljs-string">"#"</span>&gt;</span>Action<span class="hljs-tag">&lt;/<span class="hljs-name">a</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">li</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">li</span>&gt;</span><span class="hljs-tag">&lt;<span class="hljs-name">a</span> <span class="hljs-attr">href</span>=<span class="hljs-string">"#"</span>&gt;</span>Another action<span class="hljs-tag">&lt;/<span class="hljs-name">a</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">li</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">li</span>&gt;</span><span class="hljs-tag">&lt;<span class="hljs-name">a</span> <span class="hljs-attr">href</span>=<span class="hljs-string">"#"</span>&gt;</span>Something else here<span class="hljs-tag">&lt;/<span class="hljs-name">a</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">li</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">n3-dropdown</span>&gt;</span>
</code></pre>
<pre v-pre=""><code v-pre="" class="language-javascript"><span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
  data () {
    <span class="hljs-keyword">return</span> {
      <span class="hljs-attr">show</span>: <span class="hljs-literal">false</span>
    }
  }
}
</code></pre>
<h3>参数</h3>
<table>
<thead>
<tr>
<th>参数名</th>
<th>类型</th>
<th>默认值</th>
<th>说明</th>
</tr>
</thead>
<tbody>
<tr>
<td>show</td>
<td><code v-pre="">Boolean</code></td>
<td><code v-pre="">false</code></td>
<td>是否显示</td>
</tr>
<tr>
<td>trigger</td>
<td><code v-pre="">String</code> 如: <code v-pre="">click``hover</code></td>
<td>click</td>
<td>触发方式</td>
</tr>
<tr>
<td>click-close</td>
<td><code v-pre="">Boolean</code></td>
<td><code v-pre="">false</code></td>
<td>点击关闭</td>
</tr>
</tbody>
</table>
</div>
</template>

</section></template>

<script>
export default {
  data () {
    return {
      show: false
    }
  }
}
</script>


// WEBPACK FOOTER //
// n3DropdownDocs.md?6cd8cc66